export default "__VITE_ASSET__B0uY8N1R__"